import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RouteInfo } from './sidebar.metadata';

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    private readonly _refreshSidebar = new Subject<void>();
    refreshSidebar$ = this._refreshSidebar.asObservable();

    constructor(
        private http: HttpClient
    ) {}

    /**
     * Get sidebar menu items from JSON file
     * @returns Observable<RouteInfo[]>
     */
    getRouteInfo(): Observable<RouteInfo[]> {
        // Assuming the JSON file is in the assets folder
        return this.http
            .get<{ routes: RouteInfo[] }>('assets/data/routes.json')
            .pipe(map((response) => response.routes));
    }

    refreshSidebar(){
        this._refreshSidebar.next();
    }
}
